<h3>Third-party analytics</h3>

<mat-slide-toggle [checked]="initialChecked" (change)="toggleTracking($event)">
  Allow data third-party analytics.
</mat-slide-toggle>

<p>
  We use third-party analysis tools (provided by Google, Mixpanel and Facebook)
  to determine how we can improve Fociva. We use these services to connect the
  actions that you took on our website in the lead up to you registering for our
  service and what you subsequently do on Fociva.
</p>
<p>
  The data we send to these services includes the pages you view and the
  purchases you make. These services may link data we provide to them to other
  data they collect about you on their site or on other sites.
</p>
